import { useState } from "react";

import "./AdminEccomerce.css";

import AjustesCadastrais from "./components/AdminAjustesCadastrais/AdminAjustesCadastrais";
import AdminSolicitacoes from "./components/AdminSolicitacoes/AdminSolicitacoes";
import TokenRoute from "../../components/utils/TokenRoute";

export default function AdminEccomerce() {
  const [aba, setAba] =
    useState("solicitacoes");

  return (
    <div className="admin-eccomerce">
      <TokenRoute />

      <div className="admin-tabs">

        <button
          className={
            aba === "solicitacoes"
              ? "admin-tab ativo"
              : "admin-tab"
          }
          onClick={() =>
            setAba("solicitacoes")
          }
        >
          Solicitações Cadastrais
        </button>
        <button
          className={
            aba === "ajustescadastrais"
              ? "admin-tab ativo"
              : "admin-tab"
          }
          onClick={() =>
            setAba("ajustescadastrais")
          }
        >
          Ajustes Cadastrais
        </button>

      </div>

      <div className="admin-conteudo">

        {aba === "ajustescadastrais" ? (
          <AjustesCadastrais />
        ) : (
          <AdminSolicitacoes />
        )}

      </div>

    </div>
  );
}